$(document).ready(function () {

  if (typeof objectFitImages === 'function') {
    objectFitImages();
  } else {
    console.warn('objectFitImages is not defined');
  }
  //Debugger
  var isDebug = false; // Turn this to false when finally committing to the
                       // repo and or production

  // -- Variables -- //
  var isVisible = false;
  var autoCompleteInput = $('.ui-autocomplete-input');
  var qrCodeTrigger = $(".webchat-button");
  var qrCode = $(".webchat-qrcode");
  var qrCodeOpenClassName = "qr-open";

  //Location Nav Mobile
  var locationNavBtn = $('[data-js="locationNavBtn"]');
  var locationNavContent = $('[data-js="locationNavContent"]');

  //Accoridan
  var accordionBtn = $(".accordion__btn");
  var accordionPanel = $('.accordion__panel');

  //Smooth Scroll
  var animationSpeed = 350;

  //Autocomplete
  var typingTimer;
  var doneTypingInterval = 1000;

  //Video Play button
  var videoPlayButton,
    videoWrapper = $('.video-wrapper:not(.remote):not(.no-controls):not()'),
    video = $('video:not(.video-component)');


  /*-------------------------------------------------------------------------------------
   Helper Methods
   1. isMobile Device - Checks if the page is viewed on Mobile or not returns a boolean
  --------------------------------------------------------------------------------------*/
  const isMobileDevice = function () {
    return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1);
  };

  const isMobile = isMobileDevice();

  // ToDo: tidy this up we dont need two ways of defining mobile but the isMobile const its not working reliably or me
  const mobile = window.matchMedia( "(max-width: 1239px)" );


  /*----------------------------------------------------------------------------
  Methods
  ----------------------------------------------------------------------------*/


  //Tabs
  jfTabModule.init();

  //Modal
  jfModal.init();

  //Get Local Time

  const localTimeElement = document.querySelector('.local-time');

  if (localTimeElement !== null) {
    const localTimeFn = GetLocalTime();
    localTimeFn.init();
  }

  // show/hide
  var toggleVisibility = function (element, className) {
    isVisible = !isVisible;
    if (isVisible) {
      element.addClass(className);
    } else {
      element.removeClass(className);
    }
  };

  //Mobile Location Toggle

  if (isMobile) {
    locationNavBtn.on("click", function (e) {
      e.preventDefault();
      $(locationNavContent).toggleClass('open');
    })
  }

  // select search tab if it has been set in the form
  if ($('#edit-type').length) {
    var selectedCategory = $("#edit-type :selected").data('category');
    var activeCategory = $("[data-category='" + selectedCategory + "']");
    $('.tab__list-item').removeClass('active');
    $(activeCategory).addClass('active');
  }

  //show/hide qrcode
  qrCodeTrigger.on("click", function (e) {
    e.preventDefault();
    var parentContainer = this.closest('.social-container');
    var qrCodes = $(parentContainer).find('.webchat-qrcode');
    var webchatQRCode = qrCodes.filter('[data-qrcode="' + this.getAttribute('data-qrcode') + '"]');
    // Only one QR code open at a time.
    qrCodes.not(webchatQRCode).slideUp();
    webchatQRCode.slideToggle();
  });


  //Search AutoComplete

  const captureSearchTerm = function (e) {
    return e.target.value;
  }

  const createArrayOfSearchResult = function (text) {
    var textItems = document.querySelectorAll('.autocomplete-suggestion-label');
    Array.prototype.forEach.call(textItems, function (item) {
      var originalText = item.innerHTML;

      var textItem = item.innerHTML.toLowerCase();
      var index = textItem.indexOf(text);

      if (index >= 0) {
        originalText = originalText.substring(0, index) + "<span class='search-found'>" + originalText.substring(index, index + text.length) + "</span>" + originalText.substring(index + text.length);
        item.innerHTML = originalText;
      }
    })
  };

  $(autoCompleteInput).keyup(function (e) {
    const inputValue = captureSearchTerm(e);
    clearTimeout(typingTimer);
    if ($(autoCompleteInput).val) {
      typingTimer = setTimeout(function () {

        console.log(inputValue)
        createArrayOfSearchResult(inputValue);
      }, doneTypingInterval)
    }
  })

  // homepage spotlight scroll
  $('[data-js="spotlightScroll"]').click(function (e) {
    e.preventDefault();
    var hrefAttrib = $(this).attr('href');
    if ($(hrefAttrib).length > 0) {
      var position = $(hrefAttrib).offset().top;
      $("body, html").animate({
          scrollTop: position
        },
        500
      );
    }
  });

  //Global accordion
  $(accordionBtn).click(function () {
    $(this).next(accordionPanel).slideToggle();
    $(this).toggleClass('active');
  });

  // Global Smooth Scroll
  /* Select all links with hashes */
  $('.js-smooth-scroll').on("click", function (event) {
    // On-page links only
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top
        }, (animationSpeed * 2));
      }
    }

  })


  const getData = function (clickedUrl) {
    $.ajax({
      url: clickedUrl,
      success: function (data) {
        data = $(data).find('.tab-container');
        $('.tab-container').html(data);
      },
      error: function (error) {
        console.log(error);
      }
    })
  }


  /*----------------------------------------------------------------------------
  Global tabbed nav
  ----------------------------------------------------------------------------*/
  var changeTabContent = function (tabItem) {
    // Toggle active class on tabs.
    tabItem.siblings('.active').removeClass('active');
    tabItem.addClass('active');

    const clickedUrl = tabItem.data('url');

    if (clickedUrl !== undefined) {
      //Ajax call to the country listing url
      getData(clickedUrl);
    }

    // Find the tab pane with matching data attribute.
    var tabName = tabItem.attr('name');
    var activePane = $(".tab-content").find("[data-tab='" + tabName + "']");
    // Make this one the active pane.
    $('.tab-content__pane').removeClass('active');

    $(activePane).addClass('active');

    // Put the selected tab to URL.
    window.location.hash = tabName;

    // Update the search form 'type' filter after tab click.
    if ($('#edit-type').length) {
      var activeTab = $(".tab-select").find("[data-category='" + tabItem.data('category') + "']");
      $('#edit-type').val(activeTab.val());
      $('#views-exposed-form-search-results-page-1').submit();
    }
  }

  var tabContent = function () {
    // Check if there is a hash in url.
    var urlHash = window.location.hash.substr(1);
    var tabSelector = urlHash.replaceAll('%20', ' ');


    if (tabSelector.length > 0 && $('.tab .tab__list-item[name="' + tabSelector + '"]').length > 0) {
      var selectedElement = $('.tab .tab__list-item[name="' + tabSelector + '"]');
      // Toggle active class on tabs.
      selectedElement.siblings('.active').removeClass('active');
      selectedElement.addClass('active');

      const clickedUrl = selectedElement.data('url');

      if (clickedUrl !== undefined) {
        //Ajax call to the country listing url.
        getData(clickedUrl);
      }

      // Find the tab pane with matching data attribute.
      var tabName = selectedElement.attr('name');
      var activePane = $(".tab-content").find("[data-tab='" + tabName + "']");
      // Make this one the active pane.
      $('.tab-content__pane').removeClass('active');

      $(activePane).addClass('active');

      // Put the selected tab to URL.
      window.location.hash = tabName;

      // Update the search form 'type' filter after tab click.
      if ($('#edit-type').length) {
        var activeTab = $(".tab-select").find("[data-category='" + selectedElement.data('category') + "']");
        $('#edit-type').val(activeTab.val());
        $('#views-exposed-form-search-results-page-1').submit();
      }
    }

    // Tab functionality for tablet and above.
    $('.tab .tab__list-item').on("click", function (e) {
      e.preventDefault();
      changeTabContent($(this));
    });

  }

  tabContent();


  // Tab functionality - dropdown for mobile
  $('#tab-select').on('change', function (e) {
    $('.tab-content__pane').removeClass('active');
    var selectedName = $(this).val();
    $("[data-tab='" + selectedName + "']").addClass('active');
  });

  $('#edit-type').on('change', function (e) {
    $('#views-exposed-form-search-results-page-1').submit();
  });

  /*----------------------------------------------------------------------------
  Carousel
  ----------------------------------------------------------------------------*/
  // Bottom and responsive carousels carousel
  $('.owl-carousel').each(function (index, el) {

    if (window.outerWidth >= 768 && $(el).hasClass('owl-carousel-sm') && !$(el).hasClass('slider--desktop')) {
      return true;
    }

    var containerHeight = $(el).height();
    $(el).find(".js_slide").each(function (index, slide) {
      var w = parseInt($(slide).width()) + parseInt($(slide).css('padding-left')) + parseInt($(slide).css('padding-right')) + 1;
      var h = $(slide).height();
      $(slide).css({
        'width': w + 'px',
        'height': containerHeight + 'px'
      });
    }),
      $(el).owlCarousel({
        autoWidth: true,
        dots: true,
        nav: true,
        loop: false,
        items: 2
      });
  });

  // carousel with 1 item
  $('.owl-carousel-1').each(function (index, el) {

    if (window.outerWidth >= 768 && $(el).hasClass('owl-carousel-sm')) {
      return true;
    }

    var containerHeight = $(el).height();
    $(el).find(".js_slide").each(function (index, slide) {
      var w = parseInt($(slide).width()) + parseInt($(slide).css('padding-left')) + parseInt($(slide).css('padding-right')) + 1;
      var h = $(slide).height();
      $(slide).css({
        'width': w + 'px',
        'height': containerHeight + 'px'
      });
    }),
      $(el).owlCarousel({
        dots: true,
        nav: true,
        loop: false,
        responsiveClass: true,
        items: 1
      });
  });


  window.addEventListener('resize', function () {
    const carouselItem = $('.owl-stage-outer');
    if ($(carouselItem).length) {
      //location.reload();
    }
  });

  /*----------------------------------------------------------------------------
  Conditionally load Lazy Load
  https://github.com/verlok/lazyload#using-an-async-script--getting-the-instance-reference
  ----------------------------------------------------------------------------*/
  (function (w, d) {
    var b = d.getElementsByTagName('body')[0];
    var s = d.createElement("script");
    var v = !("IntersectionObserver" in w) ? "8.17.0" : "10.19.0";
    s.async = true; // This includes the script as async. See the "recipes"
                    // section for more information about async loading of
                    // LazyLoad.
    s.src = "https://cdn.jsdelivr.net/npm/vanilla-lazyload@" + v + "/dist/lazyload.min.js";
    w.lazyLoadOptions = {
      elements_selector: ".lazy"
    };
    // Listen to the initialization event and get the instance of LazyLoad
    w.addEventListener('LazyLoad::Initialized', function (event) {
      w.lazyLoadInstance = event.detail.instance;
    }, false);
    b.appendChild(s);
  }(window, document));

  /*----------------------------------------------------------------------------
  Display video play button on load and then hide
  ----------------------------------------------------------------------------*/
  videoMethods = {
    renderVideoPlayButton: function () {
      //If this is an uploaded video
      if (videoWrapper.has(video)) {
        AddVideoPlayButton()
        video.addClass('has-media-controls-hidden')
        videoPlayButton = $('.video-overlay-play-button');
        videoPlayButton.on("click", function (e) {
          hideVideoPlayButton(e)
        });
      }
    }
  }

  //Add Video play button to uploaded videos
  var AddVideoPlayButton = function () {
    videoWrapper.append('\
      <svg class="video-overlay-play-button" viewBox="0 0 85 85">\
          <g id="Desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\
              <g id="T5-Sub-Category---Sector-type" transform="translate(-757.000000, -1328.000000)">\
                  <g id="Video" transform="translate(404.000000, 1000.000000)">\
                      <g id="Play-button" transform="translate(353.000000, 328.000000)">\
                          <circle id="Oval-2" fill="var(--space-blue,#3F80FF)" fill-rule="nonzero" cx="42.5" cy="42.5" r="42.5"></circle>\
                          <g id="play" transform="translate(35.000000, 25.000000)" stroke="#FFFFFF" stroke-linejoin="bevel">\
                              <g id="Shape">\
                                  <path d="M0.331730769,0.106046512 L22.1397115,17.8953488 C22.3888772,18.1439858 22.5288804,18.4813761 22.5288804,18.8331977 C22.5288804,19.1850192 22.3888772,19.5224095 22.1397115,19.7710465 L0.331730769,37.6001163 L0.331730769,0.106046512 Z" stroke-width="2.25"></path>\
                              </g>\
                          </g>\
                      </g>\
                  </g>\
              </g>\
          </g>\
      </svg>\
    ')
  };

  //Hide play button and play video, display controls
  var hideVideoPlayButton = function (e) {
    var parent = $(e.currentTarget).siblings().get(0);
    var children = $(parent).children('video');

    children.get(0).play()
    $(e.currentTarget).addClass('is-hidden')
    children.removeClass('has-media-controls-hidden')
  }

  videoMethods.renderVideoPlayButton();


  var video_play_classes= '.paragraph--type--content, .paragraph--type--scroll-reveal, .paragraph--type--text-media, .slide-card-container-paragraph, .paragraph--type--scroll-transform, .paragraph--type--hero-banner, .paragraph--type--hero-banner-gtm, .paragraph--type--basic-content-block';
  $(video_play_classes).find('.media--type-video .has-media-controls-hidden').each(function(e) {
    this.controls = false;
    $(this).on('click', function () {
      if (this.paused) {
        this.play();
      } else {
        this.pause();
      }
    });
    var play = $(this).next('.video--play');
    play.bind('click', function(e) {
      $(this).prev('video').each(function(index){
        $(this).get(0).play();
      });
      $(this).fadeOut("slow");
    });
    $(video).bind('play', function () {
      $(this).next('.video--play').fadeOut("slow");
    });
    $(video).bind('pause', function () {
      $(this).next('.video--play').fadeIn("slow");
    });
    $(video).bind('ended', function () {
      $(this).next('.video--play').fadeIn("slow");
    });
  });

});
